/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsitenoplaceerror4Inputs */

const en_placewebsitenoplaceerror4 = /** @type {(inputs: Placewebsitenoplaceerror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We found no place on that website. Create it without a website.`)
};

const de_placewebsitenoplaceerror4 = /** @type {(inputs: Placewebsitenoplaceerror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf der Website haben wir keinen Ort gefunden. Leg ihn ohne Website an.`)
};

/**
* | output |
* | --- |
* | "We found no place on that website. Create it without a website." |
*
* @param {Placewebsitenoplaceerror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsitenoplaceerror4 = /** @type {((inputs?: Placewebsitenoplaceerror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsitenoplaceerror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsitenoplaceerror4(inputs)
	return de_placewebsitenoplaceerror4(inputs)
});
export { placewebsitenoplaceerror4 as "placeWebsiteNoPlaceError" }